import styled from 'styled-components';
import theme from '../../theme';

export const TerminalSelect = styled.select`
  background: ${theme.colors.bgSecondary};
  border: 1px solid ${theme.colors.border};
  color: ${theme.colors.text};
  padding: 0.75rem 1rem;
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.fast};
  width: 100%;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.borderBright};
    box-shadow: 0 0 10px ${theme.colors.overlayLight};
  }
  
  option {
    background: ${theme.colors.bgTertiary};
    color: ${theme.colors.text};
  }
`;

export const TerminalTextarea = styled.textarea`
  background: ${theme.colors.bgSecondary};
  border: 1px solid ${theme.colors.border};
  color: ${theme.colors.text};
  padding: 0.75rem 1rem;
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.fast};
  width: 100%;
  min-height: 100px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.borderBright};
    box-shadow: 0 0 10px ${theme.colors.overlayLight};
  }
  
  &::placeholder {
    color: ${theme.colors.textMuted};
  }
`;

export const TerminalLabel = styled.label`
  font-family: ${theme.fonts.mono};
  font-weight: 600;
  color: ${theme.colors.text};
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
  display: block;
  
  &::before {
    content: '> ';
    color: ${theme.colors.primary};
  }
`;

export const TerminalCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: ${theme.colors.primary};
`;

export const TerminalCheckboxLabel = styled.label`
  font-family: ${theme.fonts.mono};
  color: ${theme.colors.text};
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  
  &:hover {
    color: ${theme.colors.primaryLight};
  }
`;

export const TerminalTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  background: ${theme.colors.bgTertiary};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  overflow: hidden;
`;

export const TerminalTableHeader = styled.thead`
  background: ${theme.colors.bgSecondary};
  border-bottom: 2px solid ${theme.colors.borderBright};
`;

export const TerminalTableHeaderCell = styled.th`
  padding: 1rem;
  text-align: left;
  font-weight: 700;
  color: ${theme.colors.primary};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.75rem;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const TerminalTableRow = styled.tr`
  border-bottom: 1px solid ${theme.colors.border};
  transition: all ${theme.transitions.fast};
  
  &:hover {
    background: ${theme.colors.overlayLight};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const TerminalTableCell = styled.td`
  padding: 1rem;
  color: ${theme.colors.text};
  border-bottom: 1px solid ${theme.colors.border};
`;

export const TerminalAlert = styled.div`
  padding: 1rem 1.5rem;
  border-radius: ${theme.borderRadius.md};
  margin: 1rem 0;
  font-family: ${theme.fonts.mono};
  font-size: 0.875rem;
  border: 1px solid;
  
  &.error {
    background: rgba(255, 0, 64, 0.1);
    color: ${theme.colors.error};
    border-color: ${theme.colors.error};
    
    &::before {
      content: '[ERROR] ';
      color: ${theme.colors.error};
      font-weight: 700;
    }
  }
  
  &.success {
    background: rgba(0, 255, 65, 0.1);
    color: ${theme.colors.success};
    border-color: ${theme.colors.success};
    
    &::before {
      content: '[SUCCESS] ';
      color: ${theme.colors.success};
      font-weight: 700;
    }
  }
  
  &.warning {
    background: rgba(255, 170, 0, 0.1);
    color: ${theme.colors.warning};
    border-color: ${theme.colors.warning};
    
    &::before {
      content: '[WARNING] ';
      color: ${theme.colors.warning};
      font-weight: 700;
    }
  }
`;

export const TerminalLoading = styled.div`
  text-align: center;
  padding: 3rem;
  font-family: ${theme.fonts.mono};
  font-size: 1rem;
  color: ${theme.colors.text};
  
  &::before {
    content: 'root@quantdelta~# ';
    color: ${theme.colors.primary};
  }
`;

